function AdminPanel(){
    window.location.replace('https://project-tracker-phase5.herokuapp.com/admin')

    return null
}

export default AdminPanel